"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _IndicatorButton = _interopRequireDefault(require("../IndicatorButton"));
var _icons = require("../../icons");
var _TooltipContent = require("../../TooltipContent");
var _constants = require("../../../constants");
var _enums = require("../../../types/enums");
var _context = require("../../../context");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const InfoIndicatorButton = () => {
  const {
    FEEDBACK_COOKIE_NAME,
    FEEDBACK_URL,
    INTERACTION_COOKIE_NAME
  } = _constants.configs;
  const {
    showFeedback,
    usingContentSync,
    currentBuildStatus,
    manifestInfo,
    buildInfo,
    setCookie,
    trackEvent
  } = (0, _react.useContext)(_context.IndicatorContext);
  const showAlertInfoIcon = (0, _react.useMemo)(() => showFeedback || (manifestInfo === null || manifestInfo === void 0 ? void 0 : manifestInfo.redirectUrl) || (manifestInfo === null || manifestInfo === void 0 ? void 0 : manifestInfo.errorMessage) ||
  // we only use build statuses to update UI state when not running content sync logic
  !usingContentSync && currentBuildStatus && [_enums.BuildStatus.SUCCESS, _enums.BuildStatus.ERROR].includes(currentBuildStatus), [currentBuildStatus, showFeedback, manifestInfo]);
  const baseButtonProps = (0, _react.useMemo)(() => {
    return {
      testId: `info`,
      icon: showAlertInfoIcon ? _icons.infoAlertIcon : _icons.infoIcon,
      disabled: false,
      showSpinner: false,
      tooltip: {
        content: ``,
        trigger: `hover`
      }
    };
  }, [showAlertInfoIcon]);
  const [buttonProps, setButtonProps] = (0, _react.useState)(baseButtonProps);
  const trackClickEvent = () => {
    trackEvent({
      eventType: _enums.EventType.PREVIEW_INDICATOR_CLICK,
      name: `info click`
    });
  };
  const trackHoverEvent = () => {
    trackEvent({
      eventType: _enums.EventType.PREVIEW_INDICATOR_HOVER,
      name: `info hover`
    });
  };
  const updateTooltipVisibility = visible => {
    setButtonProps(btnProps => {
      const newProps = {
        ...btnProps
      };
      if (newProps.tooltip) {
        newProps.tooltip.visible = visible;
      }
      return newProps;
    });
  };
  const closeInfoTooltip = () => {
    trackClickEvent();
    updateTooltipVisibility(false);
  };
  const toggleTooltip = () => {
    var _buttonProps$tooltip;
    trackClickEvent();
    updateTooltipVisibility(!((_buttonProps$tooltip = buttonProps.tooltip) !== null && _buttonProps$tooltip !== void 0 && _buttonProps$tooltip.visible));
  };
  const resetFeedbackLoop = () => {
    const now = new Date();
    setCookie(FEEDBACK_COOKIE_NAME, now.toISOString());
    setCookie(INTERACTION_COOKIE_NAME, `0`);
  };
  const closeFeedbackTooltip = () => {
    setButtonProps(btnProps => {
      const newProps = {
        ...btnProps
      };
      newProps.highlighted = false;
      if (newProps.tooltip) {
        newProps.tooltip.visible = false;
      }
      return newProps;
    });
  };
  (0, _react.useEffect)(() => {
    const infoButtonProps = {
      ...baseButtonProps,
      onClick: trackClickEvent
    };
    const prepareForMessage = (message, trigger = `none`, showSpinner = true) => {
      infoButtonProps.showSpinner = showSpinner;
      if (showSpinner) {
        infoButtonProps.clickable = !showSpinner;
      }
      if (infoButtonProps.tooltip) {
        infoButtonProps.tooltip.trigger = trigger;
        infoButtonProps.tooltip.visible = trigger === `none`;
        infoButtonProps.tooltip.content = message;
      }
    };
    const dispatcher = {
      [_enums.BuildStatus.UP_TO_DATE]: () => {
        infoButtonProps.disabled = false;
        if (showFeedback) {
          infoButtonProps.highlighted = true;
          if (infoButtonProps.tooltip) {
            infoButtonProps.tooltip.trigger = `manual`;
            infoButtonProps.tooltip.visible = true;
            infoButtonProps.tooltip.content = /*#__PURE__*/_react.default.createElement(_TooltipContent.FeedbackTooltipContent, {
              url: FEEDBACK_URL,
              onURLOpened: closeFeedbackTooltip
            });
            infoButtonProps.tooltip.onClose = closeFeedbackTooltip;
            infoButtonProps.tooltip.onDisappear = resetFeedbackLoop;
          }
        } else {
          var _buildInfo$currentBui;
          if (buildInfo !== null && buildInfo !== void 0 && (_buildInfo$currentBui = buildInfo.currentBuild) !== null && _buildInfo$currentBui !== void 0 && _buildInfo$currentBui.createdAt) {
            prepareForMessage(_constants.messages.previewUpdated(new Date(buildInfo.currentBuild.createdAt)), `hover`, false);
          }
        }
      },
      [_enums.BuildStatus.SUCCESS]: () => {
        infoButtonProps.disabled = false;
        infoButtonProps.onClick = toggleTooltip;
        if (infoButtonProps.tooltip) {
          infoButtonProps.tooltip.visible = true;
          infoButtonProps.tooltip.trigger = `click`;
          infoButtonProps.tooltip.content = /*#__PURE__*/_react.default.createElement(_TooltipContent.BuildSuccessTooltipContent, null);
          infoButtonProps.tooltip.onClose = closeInfoTooltip;
        }
      },
      [_enums.BuildStatus.ERROR]: () => {
        infoButtonProps.disabled = false;
        infoButtonProps.onClick = toggleTooltip;
        if (infoButtonProps.tooltip) {
          infoButtonProps.tooltip.visible = true;
          infoButtonProps.tooltip.trigger = `manual`;
          infoButtonProps.tooltip.content = /*#__PURE__*/_react.default.createElement(_TooltipContent.BuildErrorTooltipContent, null);
          infoButtonProps.tooltip.onClose = closeInfoTooltip;
        }
      },
      [_enums.BuildStatus.BUILDING]: () => prepareForMessage(_constants.messages.buildingPreview),
      [_enums.BuildStatus.QUEUED]: () => prepareForMessage(_constants.messages.kickingOffBuild),
      [_enums.BuildStatus.UPLOADING]: () => prepareForMessage(_constants.messages.deploying)
    };

    // with the introduction of Content Sync eager redirects, button state is no longer tied to build status. So we need a separate action for Content Sync.
    if (usingContentSync) {
      prepareForMessage(_constants.messages.buildingNewPreview);
      infoButtonProps.showSpinner = true;
      if (manifestInfo !== null && manifestInfo !== void 0 && manifestInfo.redirectUrl) {
        window.location.href = manifestInfo.redirectUrl;
      }
      if (manifestInfo !== null && manifestInfo !== void 0 && manifestInfo.redirectUrl && infoButtonProps.tooltip) {
        infoButtonProps.showSpinner = false;
        infoButtonProps.onClick = toggleTooltip;
        infoButtonProps.tooltip.content = /*#__PURE__*/_react.default.createElement(_TooltipContent.BuildSuccessTooltipContent, null);
        infoButtonProps.tooltip.visible = false;
        infoButtonProps.clickable = false;
        infoButtonProps.highlighted = false;
        infoButtonProps.tooltip.trigger = `click`;
        infoButtonProps.tooltip.onClose = closeInfoTooltip;
      }
    } else if (!(manifestInfo !== null && manifestInfo !== void 0 && manifestInfo.errorMessage) && !usingContentSync && currentBuildStatus) {
      const runUpdates = dispatcher[currentBuildStatus];
      runUpdates();
    }
    setButtonProps(infoButtonProps);
  }, [currentBuildStatus, showFeedback, baseButtonProps, manifestInfo]);
  return /*#__PURE__*/_react.default.createElement(_IndicatorButton.default, (0, _extends2.default)({}, buttonProps, {
    onMouseEnter: !(buttonProps !== null && buttonProps !== void 0 && buttonProps.disabled) ? trackHoverEvent : undefined
  }));
};
var _default = InfoIndicatorButton;
exports.default = _default;